export const AppRoute = {
    // Public
    SignIn: "/sign-in",
    // Private
    Home: "/",
    Record: "/record",
    RecordPreview: "/preview/:id",
};
